var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('h1',{staticClass:"title"},[_vm._v("Short{Paste}")]),_c('div',{staticClass:"tab-wrapper"},[_c('Tabs',{staticClass:"tabs"},[_c('TabItem',{attrs:{"name":"Link"}},[_c('Link')],1),_c('TabItem',{attrs:{"name":"Text"}},[_c('Paste')],1),_c('TabItem',{attrs:{"name":"File"}},[_c('File')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }